import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrash, faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';
const FormsList = () => {
    const navigate = useNavigate();
    const [value, setvalue] = useState("");
    const [formsData, setFormsData] = useState([]);
    const [deleteCode, setDeleteCode] = useState({})

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/forms`);
            setFormsData(result.data.dataContent);
        };
        fetchData();
    }, []);

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'formName',
                header: 'Forms Name',
            },
            {
                accessorKey: 'schemeName',
                header: 'Scheme Name',
            },
            {
                accessorKey: 'formAction',
                header: 'Forms Action',
            },
            {
                accessorKey: 'formController',
                header: 'Forms Controller',
            },
            {
                accessor: '',
                header: 'Actions',
                Cell: cell => <>
                    <i className="btn text-primary" type="button" onClick={() => navigate("/usermanagement/formslist", { state: { cropSurveyCode: cell.row.original } })}><FontAwesomeIcon icon={faPencil} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_form" onClick={() => setDeleteCode({ "rO_FormCode": cell.row.original.rO_FormCode })}> <FontAwesomeIcon icon={faTrashAlt} /></i></>
                
            },
        ],
        [],
    );

    function deleteData(value) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(deleteCode);

        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/forms`, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (JSON.parse(result).success == true) {
                    fetchData2()

                }
            })
            .catch(error => console.log('error', error));
    }

    async function fetchData2() {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/forms`);
        setFormsData(result.data.dataContent);
    }

    return (
        <>
           
            <main id="main" className="main">
               
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                          <nav>
                        <h1>Forms</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">Forms</li>
                        </ol>
                    </nav>
                    <button type="button" className="btn btn-success" onClick={() => navigate("/usermanagement/formslist")}>Add New Form</button>
                </div>
             
                <section className="section">
                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={formsData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                />
                            </div>

                        </div>

                    </div>
                </section>

            </main>

            <div className="modal fade" id="staticBackdrop_form" data-bs-backdrop="staticBackdrop_form" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div className="modal-body">
                            <h6 id="deleteHeading">Are you sure you want to delete this item?</h6>


                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                            <button type="button" className="btn border" data-bs-dismiss="modal">No</button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FormsList;

